import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing a table report view.
 * @extends JetView
 */
export default class tableReportView extends JetView {
    /**
     * Configures the datatable view.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('league', true); // Current user league parameter

        return {
            view: 'datatable', // Datatable view
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            columns: [
                // Column definitions
                { id: 'Id', header: _('ID Usuario'), width: 100, sort: 'int' }, // User ID column
                {
                    id: 'Name',
                    header: _('Nombre Usuario'),
                    width: 250,
                    sort: 'string', // User Name column
                },
                {
                    id: 'State',
                    header: _('Estado'),
                    options: [
                        // State options for dropdown
                        { id: '', value: _('None') },
                        { id: 'A', value: _('Activado') },
                        { id: 'C', value: _('Cancelado') },
                        { id: 'I', value: _('Inactivado') },
                    ],
                    width: 100,
                    sort: 'int', // State column
                },
                {
                    id: 'CreatedLocalDate',
                    header: _('Fecha de Creación'),
                    width: 200,
                    sort: 'int', // Creation date column
                },
                {
                    id: 'LastLoginLocalDate',
                    header: _('Fecha del ultimo logueo'),
                    width: 200,
                    sort: 'int', // Last login date column
                },
            ],
            on: {
                // Event handlers
                onItemDblClick: (id) => {
                    // Double-click event
                    window.location.href = '#!/top/customers?league=' + id + '/information'; // Redirect to customer information
                },
            },
            math: true, // Enable math operations
            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
            pager: 'pagerA', // Pager ID
            // API URL for fetching data
            url: devConfig.geturlApi() + 'es/League/GetUsersAffiliates?LeagueId=' + cur_user + '&',
        };
    }

    /**
     * Initializes the datatable and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const cur_user = this.getParam('league', true); // Current user league parameter
        var url = grid.data.url; // Data URL for the grid

        this.on(this.app, 'userAffiliates:filter', (filterData) => {
            // Filter event listener
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for filters

            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Non-object filters
                    if (object[i][0] == 'Datepicker') {
                        // Datepicker filter
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object filter to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object filters
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // End date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&LeagueId=' + cur_user; // Append league ID to query
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
        });

        grid.attachEvent('onItemClick', function (id, e, node) {
            // Item click event
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        this.on(this.app, 'player:select', (Id) => {
            // Player select event listener
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + user, // Load grid data based on selected player
            );
        });
    }
}

// FILE DOCUMENTED
